import { createFileRoute, Outlet } from "@tanstack/react-router";

/** The services: the list, a new one, and one service's page. */
export const Route = createFileRoute("/_app/catalog/services")({
  component: Outlet,
});
